import React from 'react'

function PageCardd(props) {
    return (
        <div className="page-card-container col-sm-6 col-md-4">
            {/* hello */}
            <img src="https://via.placeholder.com/150x50" className="card-image-logo" alt=""/>
            <div className="card-body">

            <h3>Website/App Name Goes Here</h3>
            {/* <span className="pill pill-secondary  pill-sm">type goes here</span> */}
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Veritatis suscipit et voluptate voluptatibus minima totam!</p>

                <a href="#">Visit website</a>
            </div>
        </div>
    )
}

export default PageCardd
